import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonServiceLayerService, RequestPayLoadFormat } from 'src/app/services/common-service-layer.service';
import { DataTableConfig } from 'src/app/shared/table/table-interface';
import { SharedService } from 'src/app/shared/shared.service';
import { Router, ActivatedRoute } from '@angular/router';
import * as c3 from 'c3';
import * as d3 from 'd3';
import { AlertService } from 'src/app/shared/alert.service';
import { Config } from 'src/app/config/config';
import { Paho } from 'ng2-mqtt/mqttws31';
import { Location } from '@angular/common';
import { AppService } from 'src/app/app.service';


@Component({
  selector: 'app-map-municipal-dashboard-loader',
  templateUrl: './map-municipal-dashboard-loader.component.html',
  styleUrls: ['./map-municipal-dashboard-loader.component.scss']
})
export class MapMunicipalDashboardLoaderComponent implements OnInit {

  private mqttClient: Paho.MQTT.Client;
  public appliedFilters: any;
  public lat; // To Display default latitude
  public lng; // To Display default longitude
  public tableConfigData: DataTableConfig;
  public responseData;
  public errorStatusMessage;
  public siteStatusMapping;
  public activeTab = 'table';
  public currentActiveParam;
  public legendThreshold: any;
  public geoJsonObject: any;
  public tables = [];
  public currentChart: any;
  public markerData: any;
  public timerCall: any;
  public refreshMinutes: any = 3;
  public isChecked = true;
  public markers: any;
  public payLoad = {
    selectedStation: ''
  };
  public pdfData: any = {
    ReportType: 'Summary Dashboard',
    ReportName: 'Summary Dashboard'
  };
  public printMetaData: any = {
    reportName: 'Summary dashboard Chart',
    isChart: true,
    fileName: 'Summary dashboard Report',
    headerContent: this.pdfData,
    headerLabel: 'label',
    isDropDown: true
  };
  public printMetaDataChart: any = {
    reportName: 'Summary dashboard Chart',
    isChart: true,
    fileName: 'Summary dashboard Report',
    headerContent: this.pdfData,
    headerLabel: 'label',
    isDropDown: false
  };
  public printDivInfo: any = {
    id: 'stationWiseParam-charts',
    imageId: 'stationWiseParam-charts',
    imageName: 'summaryDashboardchart'
  };
  public ddOptions = { stations: [] };
  constructor(
    private http: CommonServiceLayerService,
    public sharedService: SharedService,
    public alert: AlertService,
    public router: Router,
    public route: ActivatedRoute,
    private location: Location,
    public appService: AppService
  ) {
    this.route.params.subscribe((params) => {
      this.routeParams = params;
    });
  }
  public stationName;
  public routeParams;

  ngOnInit() {
    this.siteStatusMapping = this.appService.constants.siteStatus;
    if (this.routeParams) {
      const splitId = this.routeParams.id.split('@');
      this.stationName = splitId[0];
      this.pdfData.siteName = this.stationName;
      this.printDivInfo.siteName = this.stationName;
      this.pdfData.startTime = this.sharedService.formatDate(new Date()) + ' 00:00:00';
      this.pdfData.endTime = this.sharedService.formatDate(new Date()) + ' ' + this.sharedService.formatTime(new Date());
    }
    this.getDDOptions();
    this.setTableConfig();
    // this.loadGeoJson();
  }
  ngOnDestroy() {
    try {
      clearTimeout(this.timerCall);
    } catch (error) {
      Config.logger(error);
    }
  }
  setTableConfig() {
    try {
      this.tableConfigData = {
        dtOptions: {
          maxRows: 6,
          customTableClass: 'no-class',
          searchButton: false,
          columnSearch: false,
          searchbox: false,
          displayOptions: false,
          hidePageInfo: true,
          headerLabel: 'label',
          valueBasedColor: {
            avg: 'color'
          },
          print: {
            show: false,
            isDropDown: true,
            fileName: 'Summary Dashboard',
            headerContent: this.pdfData,
            types: ['pdf', 'excel', 'csv'],
            printMetaData: {},
            headerLabel: 'label'
          }
        }
      };
    } catch (error) {
      Config.logger(error);
    }
  }
  styleFunc(feature) {
    return ({
      clickable: false,
      fillColor: '#50a3ea', // feature.getProperty('color'),
      strokeWeight: 1,
      stroke: '#50a3ea',
      fillOpacity: 0.7,
    });
  }
  loadGeoJson() {
    try {
      const request: RequestPayLoadFormat = {
        api: 'dubaiDMGeoJson',
        method: 'get',
        loader: true,
        type: 'JSON',
        hideErrorMessage: false
      };
      this.http.API_REQUEST(request).subscribe(response => {
        if (response) {
          this.geoJsonObject = response;
        } else {
          this.sharedService.serviceErrorMessage(response.message);
        }
      });
    } catch (error) {
      Config.logger(error);
    }
  }
  naivateTo() {
    try {
      this.router.navigate(['/landing/reports/realTimeReportData', this.payLoad.selectedStation]);
    } catch (error) {
      Config.logger(error);
    }
  }
  /**
   * get sites list from API
   */
  setSelectedStation(event?) {
    try {
      if (event) {
        this.responseData = undefined;
        // this.payLoad.selectedStation = this.ddOptions.stations[0].value;
      } else {
        this.payLoad.selectedStation = this.ddOptions.stations[0].value;
      }
      this.fetchLiveData();
      this.fetchMapData();
      // this.closeMQTTConnection();
      // this.setMQTTConnection();
    } catch (error) {
      Config.logger(error);
    }
  }
  getDDOptions() {
    try {

      const request: RequestPayLoadFormat = {
        api: 'getSitesList',
        method: 'postText',
        loader: true,
        type: 'API',
        hideErrorMessage: false,
        payLoad: {}
      };
      this.http.API_REQUEST(request).subscribe(response => {
        if (response.status && response.data) {
          this.ddOptions.stations = response.data.sites;
          if (this.routeParams.id) {
            this.payLoad.selectedStation = this.routeParams.id;
            this.setSelectedStation(this.routeParams.id);
          } else {
            this.setSelectedStation();
          }
        } else {
          this.sharedService.serviceErrorMessage(response.message);
        }
      });
    } catch (error) {
      Config.logger(error);
    }
  }
  fetchLiveData() {
    const inputData = {
      // avgFlag: 'parameter',
      bodyContent: {
        station: this.payLoad.selectedStation
      }
    };
    try {
      this.tableConfigData.tableData = undefined;
      // fetchDashboardDataDM
      const request: RequestPayLoadFormat = {
        api: 'fetchDashboardDataDM',
        method: 'postText',
        loader: true,
        type: 'API',
        hideErrorMessage: false,
        payLoad: inputData
      };
      this.http.API_REQUEST(request).subscribe(response => {
        if (response.status) {
          this.responseData = response.data;
          this.tableConfigData.tableData = response.data.tableData;
          this.plotChart();
        } else {
          this.errorStatusMessage = response.message;
          this.sharedService.serviceErrorMessage(response.message);
        }
      });
    } catch (error) {
      Config.logger(error);
    }
  }
  formatTableData() {
    try {
      this.tableConfigData.tableData.headerContent.forEach(element => {
        element.noSort = true;
      });
    } catch (error) {
      Config.logger(error);
    }
  }
  /**
   * generate charts
   */
  plotChart() {
    try {
      let that = this;
      const customLegend = [];
      this.legendThreshold = [];
      const maxArray = [];
      this.responseData.threshold.forEach((element, index) => {
        // if (index > 0) {
        that.legendThreshold.push([element.parameterName, element.threshold, element.low_threshold]);
        customLegend.push(element.parameterName);
        // }
      });
      this.responseData.HighCharts.columns.forEach((ele, ind) => {
        // if (ele[0] === 'date') {
        //   this.pdfData.startTime = ele[1];
        //   this.pdfData.endTime = ele[ele.length - 1];
        // }
        const param = ele.shift();
        const filterList = ele.filter(e => e !== 'NA');
        ele.unshift(param);
        // var max_of_array = Math.max.apply(Math, filteraList);
        if (filterList.length > 0) {
          const maxListArray = Math.max.apply(Math, filterList);
          maxArray.push(maxListArray);
        } else {
          // var max_of_array = [0];
          maxArray.push(0);
        }
      });
      const maxYPoint = Math.max.apply(Math, maxArray);
      const chartId = '#stationWiseParam-charts';
      const chartOptions: any = {
        bindto: chartId,
        size: {
          height: 400,
        },
        padding: {
          top: 20,
          left: 100,
          right: 60,
          bottom: 20
        },
        transition: { duration: 0 },
        zoom: { enabled: true },
        data: this.responseData.HighCharts,
        axis: {
          x: {
            type: 'timeseries',
            tick: {
              format: this.responseData.HighCharts.xFormat,
              count: 5,
            },
            label: {
              text: 'Date and Time',
              position: 'outer-right'
            },
          },
          y: {
            tick: {
              count: 5,
              format(x) {
                return x.toFixed(0);
              }
            },
            label: {
              text: 'Reading',
              position: 'outer-middle'
            },
            padding: {
              bottom: 0,
            },
            min: 0,
            max: maxYPoint + 5
          },

        },
        tooltip: {
          format: {
            value(value) {
              return d3.format(',.2f')(value);
            }
          }
        },
        legend: {
          show: false,
        },
        grid: {
          lines: {
            front: false
          },
          y: {
            show: true,
            color: 'red'
          }
        }
      };
      that.currentChart = c3.generate(chartOptions);
      d3.select(chartId).insert('div', '.chart').attr('class', 'legend').selectAll('span')
        .data(customLegend) // customLegend
        .enter().append('span')
        .attr('data-id', (id) => {
          return id;
        })
        .html((id) => {
          return id;
        })
        .each(function (id) {
          d3.select(this).style('background-color', that.currentChart.color(id));
          d3.select(this).style('color', '#fff');
          d3.select(this).style('padding', '3px 10px');
          d3.select(this).style('margin-left', '15px');
          d3.select(this).style('margin-bottom', '5px');

          // if (id == concLegend) {
          // 	d3.select(this).style('opacity', "0.6");
          // 	// $(".c3-axis.c3-axis-y2").hide();
          // 	$(".c3-axis.c3-axis-y2 .tick").hide();
          // 	$(".c3-axis-y2-label").hide()
          // }
        })
        .on('click', function (d) {
          const maxParamList: any = [];
          that.currentActiveParam = d;
          that.isChecked = true;
          let maxVal;
          const textVal: any = that.currentChart.data(d)[0].values;
          const filterList = textVal.filter(e => e.value !== 'NA');
          if (filterList.length > 0) {
            filterList.forEach(ele => {
              maxParamList.push(ele.value);
            });
            maxVal = Math.max.apply(Math, maxParamList);
            // maxArray.push(max_of_array);
          } else {
            // var max_of_array = [0];
            maxVal = 0;
          }
          that.currentChart.ygrids.remove();
          if ($(this).hasClass('activeLegend')) {
            that.currentChart.toggle(d);
            that.currentChart.show();
            $(this).removeClass('activeLegend');
            $(this).parent().find('span').removeClass('activeLegend');
            $(this).parent().find('span').removeClass('c3-legend-item-hidden');
            that.currentChart.axis.max(maxYPoint);
            that.currentChart.ygrids.remove();
            that.currentActiveParam = undefined;
            that.isChecked = true;
            return true;
          } else {
            that.currentChart.hide();
            that.currentChart.show(d);
            $(this).parent().find('span').removeClass('activeLegend');
            $(this).parent().find('span').addClass('c3-legend-item-hidden');
            $(this).toggleClass('c3-legend-item-hidden');
            $(this).addClass('activeLegend');
            that.currentChart.axis.max(maxVal + 10);
            $('.c3-ygrid-lines').css('display', 'block');
          }

          setTimeout(() => {
            that.legendThreshold.forEach((element, i) => {
              if (d === element[0]) {
                if (element[1]) {
                  if (element[0].indexOf('pH') !== -1) {  // element[1].indexOf('-') != -1
                    // let thresholds = paramTrendObj.Threshold.split('-');
                    const chartMax = that.currentChart.axis.max();
                    if (chartMax.y < parseFloat(element[1])) {
                      that.currentChart.axis.max(parseFloat(element[1]) + 15);
                    }
                    that.currentChart.ygrids.add([
                      {
                        value: parseFloat(element[1]),
                        class: 'red',
                        position: 'end',
                        text: 'Prescribed Standard ( ' + element[0] + '  value:' + parseFloat(element[1]) + ')'
                      },
                      {
                        value: parseFloat(element[2]),
                        class: 'red',
                        position: 'end',
                        text: 'Prescribed Standard ( ' + element[0] + '  value:' + parseFloat(element[2]) + ')'
                      }]
                    );

                  } else {
                    const chartMax = that.currentChart.axis.max();
                    if (chartMax.y < parseFloat(element[1])) {
                      that.currentChart.axis.max(parseFloat(element[1]) + 15);
                      // currentChart = 10;
                    } else {
                      // dynamicTxtPos = -4;
                    }
                    that.currentChart.ygrids.add({
                      value: parseFloat(element[1]),
                      class: 'red',
                      text: 'Prescribed Standard ( ' + element[0] + '  value:' + Number(element[1]) + ')'
                    });
                  }
                } else {
                  // that.alert.open("info", "Threshold values are not defined for " + d + ' Parameter', 'Message');
                }
              }
            });
          }, 100);
        });
    } catch (error) {
      Config.logger(error);
    }
  }
  toggleLimt(event, currentChart) {
    this.isChecked = !this.isChecked;

    const maxParamList = [];
    // const tLimit = this.currentChart.axis.max();
    let maxVal;
    const textVal: any = this.currentChart.data(this.currentActiveParam)[0].values;
    const filterList = textVal.filter(e => e.value !== 'NA');
    if (filterList.length > 0) {
      filterList.forEach(ele => {
        maxParamList.push(ele.value);
      });
      maxVal = Math.max.apply(Math, maxParamList);
      // maxArray.push(max_of_array);
    } else {
      // var max_of_array = [0];
      maxVal = 0;
    }
    if (this.isChecked) {
      this.legendThreshold.forEach((element, i) => {
        if (element[0] === this.currentActiveParam) {
          const chartMax = this.currentChart.axis.max();
          if (chartMax.y < parseFloat(element[1])) {
            this.currentChart.axis.max(parseFloat(element[1]) + 15);
            // currentChart = 10;
          }
        }
      });
      $('.c3-ygrid-lines').css('display', 'block');
    } else {
      this.currentChart.axis.max(maxVal + 5);
      $('.c3-ygrid-lines').css('display', 'none');
    }
  }
  fetchMapData() {
    this.markers = undefined;
    const inputData = {
      // avgFlag: 'parameter',
      bodyContent: {
        station: this.payLoad.selectedStation
      }
    };
    try {
      // geochartmapLoaderDM

      const request: RequestPayLoadFormat = {
        api: 'geochartmapLoaderDM',
        method: 'postText',
        loader: true,
        type: 'API',
        hideErrorMessage: false,
        payLoad: inputData
      };
      this.http.API_REQUEST(request).subscribe(response => {
        if (response.status) {
          this.geoJsonObject = response.data.geoJson;
          this.lat = parseFloat(response.data.siteList[0].latitude);
          this.lng = parseFloat(response.data.siteList[0].longitude);
          setTimeout(() => {
            this.markers = response.data.siteList;
            this.markers.forEach(element => {
              element.options = {
                color: 'white',
                fontWeight: 'bold',
                fontSize: '0.8rem',
                text: '' + element.siteLabel,
              };
              const icon = {
                url: '',
                scaledSize: {
                  width: 35,
                  height: 35,
                }
              };
              switch (element.SiteStatus) {
                case 'In-Active':
                  icon.url = 'assets/images/markers/red.png';
                  break;
                case 'Active':
                  icon.url = 'assets/images/markers/green.png';
                  break;
                default:
                  icon.url = 'assets/images/markers/gray.png';
                  break;
              }
              element.icon = icon;
            });
          }, 200);
        } else {
          this.sharedService.serviceErrorMessage(response.message || 'Failed to load. Please try again later.');
        }
      });
    } catch (error) {
      Config.logger(error);
    }

  }
  navigateBack() {
    this.location.back();
  }
  // Mqtt connection
  // setMQTTConnection() {
  //   const { host, port, path } = Config.MQTT_CONNECTION;
  //   this.mqttClient = new Paho.MQTT.Client(host, port, path, 'clientId_' + new Date().getTime());

  //   // on connect
  //   this.mqttClient.connect({ onSuccess: this.onConnected.bind(this) });

  //   // connection lost
  //   this.mqttClient.onConnectionLost = (responseObject: object) => {
  //     this.mqttConnectionLost(responseObject);
  //   };

  //   // on message arrived after topic subscription
  //   this.mqttClient.onMessageArrived = (message: Paho.MQTT.Message) => {
  //     this.onMqttMessageArrived(message);
  //   };

  // }
  // onConnected() {
  //   this.mqttClient.subscribe(``, {});
  //   // console.log('Mqtt connected');

  // }
  // mqttConnectionLost(message) {
  //   console.log('connection lost', message);
  // }
  // onMqttMessageArrived(message) {
  //   console.log('message arrived', message);
  //   this.updateLiveValues(message);
  // }
  // closeMQTTConnection() {
  //   try {
  //     if (this.mqttClient) {
  //       this.mqttClient.disconnect();
  //     }
  //   } catch (error) {
  //     console.log(error);
  //   }
  // }
  // updateLiveValues(data) {
  //   // const MonitoringId = data.destinationName.substring(data.destinationName.lastIndexOf('/') + 1, data.destinationName.length);
  // }


}
